import { render, staticRenderFns } from "./CostSelector.vue?vue&type=template&id=206899e0&scoped=true&"
import script from "./CostSelector.vue?vue&type=script&lang=js&"
export * from "./CostSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206899e0",
  null
  
)

export default component.exports